import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { usePage } from '@inertiajs/react';
import { X } from 'lucide-react';
import { ClaudeLogo } from '@/components/app/assistant-logo';
// Mesma chave da listagem antiga: quem fechou lá não vê de novo aqui.
const KEY = 'rp_claude_banner_closed';
const TUTORIAL = 'https://www.youtube.com/watch?v=_Prb5gMb-IE';
function YoutubeIcon() {
    return (_jsxs("svg", { viewBox: "0 0 24 24", className: "h-[18px] w-[18px]", "aria-hidden": "true", children: [_jsx("path", { fill: "#FF0000", d: "M23.5 6.5a3 3 0 0 0-2.1-2.1C19.5 3.9 12 3.9 12 3.9s-7.5 0-9.4.5A3 3 0 0 0 .5 6.5C0 8.4 0 12 0 12s0 3.6.5 5.5a3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.5.5-5.5s0-3.6-.5-5.5z" }), _jsx("path", { fill: "#FFFFFF", d: "M9.6 15.6V8.4l6.3 3.6-6.3 3.6z" })] }));
}
/** Convite para conectar a Rocket Pages ao Claude (MCP), com o tutorial em vídeo. */
export function ClaudeBanner() {
    const { app } = usePage().props;
    const [visible, setVisible] = React.useState(false);
    React.useEffect(() => {
        try {
            setVisible(localStorage.getItem(KEY) !== '1');
        }
        catch {
            setVisible(true);
        }
    }, []);
    if (!visible)
        return null;
    const close = () => {
        setVisible(false);
        try {
            localStorage.setItem(KEY, '1');
        }
        catch {
            /* navegação privada */
        }
    };
    return (_jsxs("div", { className: "relative flex flex-wrap items-center gap-4 rounded-xl border bg-gradient-to-r from-[#f8f5ff] to-[#fff6f2] py-3 pl-[18px] pr-10 dark:from-[#26232f] dark:to-[#2b2526]", children: [_jsxs("div", { className: "flex items-center gap-2.5", children: [_jsx(ClaudeLogo, {}), _jsx("span", { className: "text-lg font-light text-muted-foreground/60", "aria-hidden": "true", children: "+" }), _jsx("img", { src: app.logoMark, alt: "Rocket Pages", className: "h-7 w-7" })] }), _jsxs("div", { className: "min-w-[220px] flex-1", children: [_jsx("p", { className: "text-sm font-semibold", children: "Claude + Rocket Pages" }), _jsx("p", { className: "text-[13px] text-muted-foreground", children: "Conecte a Rocket Pages ao seu Claude e crie p\u00E1ginas incr\u00EDveis de forma f\u00E1cil." })] }), _jsxs("a", { href: TUTORIAL, target: "_blank", rel: "noreferrer", className: "inline-flex h-9 items-center gap-2 rounded-full border bg-background px-4 text-[13px] font-medium shadow-sm transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring", children: [_jsx(YoutubeIcon, {}), "Assistir tutorial"] }), _jsx("button", { type: "button", onClick: close, "aria-label": "Fechar aviso", className: "absolute right-2.5 top-2 rounded-md p-1 text-muted-foreground/70 transition-colors hover:bg-foreground/5 hover:text-foreground", children: _jsx(X, { className: "h-4 w-4" }) })] }));
}
